var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.08594V3.33594C12.5 4.51445 12.5 5.1037 12.8661 5.46982C13.2322 5.83594 13.8215 5.83594 15 5.83594H16.25",
    stroke: "#00535C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 13.3307V6.66406C3.33334 4.30704 3.33334 3.12853 4.06558 2.3963C4.79781 1.66406 5.97632 1.66406 8.33334 1.66406H11.8097C12.1503 1.66406 12.3206 1.66406 12.4738 1.7275C12.6268 1.79093 12.7473 1.91136 12.9882 2.15222L16.1785 5.34257C16.4193 5.58343 16.5398 5.70386 16.6033 5.857C16.6667 6.01015 16.6667 6.18046 16.6667 6.52109V13.3307C16.6667 15.6877 16.6667 16.8662 15.9344 17.5985C15.2022 18.3307 14.0237 18.3307 11.6667 18.3307H8.33334C5.97632 18.3307 4.79781 18.3307 4.06558 17.5985C3.33334 16.8662 3.33334 15.6877 3.33334 13.3307Z",
    stroke: "#00535C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 9.16406H13.3333M6.66666 11.6641H13.3333M6.66666 14.1641H10.1423",
    stroke: "#00535C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.27e8d2af.svg";
export { ForwardRef as ReactComponent };